import {PeppinMain, PeppinMainProps, PeppinMainState} from "../peppin-shared/PeppinApp";
import {Puppet, PuppetType, StartFragment, StartFragmentListener} from "./StartFragment";
import React from "react";
import {MainFragment} from "./MainFragment";
import {Action} from "../shared/types";
import {DownloadOutlined} from "@mui/icons-material";

export type MainProps = PeppinMainProps & {}

type MainState = PeppinMainState & {
  puppetIndex?: number,
}

export class Main extends PeppinMain<MainProps, MainState> implements StartFragmentListener {

  protected onCreateState(): MainState {
    return {
      ...super.onCreateState(),
      puppetIndex: 1,
    };
  }

  private onDownload() {
  }

  protected createToolbarActions(): Action[] {
    return [
      new Action("Download", (event) => this.onDownload(), DownloadOutlined).setVariant("contained").makeDropdown(),
    ];
  }

  renderContent(): React.ReactElement {
    return this.state.puppetIndex === undefined
      ? <StartFragment path={this.props.path} listener={this}/>
      : <MainFragment path={this.props.path} puppetIndex={this.state.puppetIndex}/>;
  }

  onCreatePuppet() {
  }

  onPuppetChosen(puppet: Puppet) {
    this.setState({
      puppetIndex: puppet.type === PuppetType.G01 ? 0 : 1,
    });
  }
}